import type { cautions as Fr } from '../fr/cautions';

/** « cautions » in English — typed on the French: a missing sentence does not compile. */
export const cautions: typeof Fr = {
  formes: { especes: 'Cash', cheque: 'Cheque', traite: 'Bill of exchange', carte: 'Card' } as Record<string, string>,
  traitee: 'Deposit processed — the deposit refund receipt is ready to print.',
  erreur: 'Error',
  titre: 'Deposits and receipts',
  sousTitre: 'Each deposit generates its own receipt, numbered and signed — when taken and when refunded',
  filtres: { detenue: 'Held', restituee: 'Refunded', retenue_partielle: 'Partial deduction', saisie: 'Forfeited', toutes: 'All' },
  detenusTitre: (m: string) => `${m} held on behalf of your customers`,
  detenusTexte: 'This money is in the till but does not belong to you: it is already excluded from your available cash.',
  vide: 'No deposits',
  colDecharge: 'Receipt', colClient: 'Customer', colContrat: 'Agreement', colForme: 'Form',
  colMontant: 'Amount', colRetenu: 'Deducted', colStatut: 'Status',
  decharge: 'Receipt',
  restitution: 'Refund',
  restituer: 'Refund',
  reserveHichem: 'Refunding a deposit is a financial operation: it is reserved for the owner.',
  restituerTitre: (n: string) => `Refund deposit ${n}`,
  detenus: (m: string) => `${m} held`,
  contrat: (n: string | undefined) => `agreement ${n}`,
  montantRetenu: 'Amount deducted',
  montantRetenuAide: 'Leave 0 to refund the full amount.',
  motif: 'Reason for the deduction (required)',
  motifPlaceholder: 'Damage found at check-in, missing fuel…',
  aRestituer: 'To refund',
  sigClient: 'Customer signature',
  sigDirecteur: 'Manager signature',
  annuler: 'Cancel',
  restituerEditer: 'Refund and issue the receipt',
};
